/** Libellés FR/EN — documents d'autorité / preuves Phase 1 */

export const DOCUMENT_TYPES = {
  preuve_grade: { fr: "Preuve de grade", en: "Grade proof" },
  certificat_dan: { fr: "Certificat de dan", en: "Dan certificate" },
  preuve_japon: { fr: "Preuve Japon", en: "Japan proof" },
  lettre_recommandation: { fr: "Lettre de recommandation", en: "Recommendation letter" },
  historique_enseignement: { fr: "Historique d'enseignement", en: "Teaching history" },
  contribution: { fr: "Contribution", en: "Contribution" },
  autorite_attribution: { fr: "Autorité d'attribution", en: "Granting authority" },
  identite: { fr: "Identité", en: "Identity" },
  autre: { fr: "Autre", en: "Other" },
};

export const DOCUMENT_VALIDATION_STATUSES = {
  a_fournir: { fr: "À fournir", en: "To provide" },
  recu: { fr: "Reçu", en: "Received" },
  recu_validation_requise: { fr: "Reçu — validation requise", en: "Received — validation required" },
  en_attente: { fr: "En attente", en: "Pending" },
  en_revision: { fr: "En révision", en: "Under review" },
  accepte: { fr: "Accepté", en: "Accepted" },
  refuse: { fr: "Refusé", en: "Refused" },
  expire: { fr: "Expiré", en: "Expired" },
  a_remplacer: { fr: "À remplacer", en: "To replace" },
};

export const IMPORT_STATUSES = {
  brouillon: { fr: "Brouillon", en: "Draft" },
  pret_apercu: { fr: "Prêt pour aperçu", en: "Ready for preview" },
  apercu_genere: { fr: "Aperçu généré", en: "Preview generated" },
  confirme: { fr: "Confirmé", en: "Confirmed" },
  annule: { fr: "Annulé", en: "Cancelled" },
  erreur: { fr: "Erreur", en: "Error" },
};

export const IMPORT_WARNING_LEVELS = {
  info: { fr: "Information", en: "Information" },
  attention: { fr: "Attention", en: "Warning" },
  bloquant: { fr: "Bloquant", en: "Blocking" },
};

export const SENSITIVITY_LEVELS = {
  public: { fr: "Public", en: "Public" },
  interne: { fr: "Interne", en: "Internal" },
  confidentiel: { fr: "Confidentiel", en: "Confidential" },
  tres_confidentiel: { fr: "Très confidentiel", en: "Highly confidential" },
};

export const DOSSIER_STATUSES = {
  incomplet: { fr: "Dossier incomplet", en: "Incomplete dossier" },
  en_revision: { fr: "En révision", en: "Under review" },
  complet_a_valider: { fr: "Complet à valider", en: "Complete — to validate" },
  pret_decision: { fr: "Prêt pour décision", en: "Ready for decision" },
  approuve: { fr: "Approuvé", en: "Approved" },
  refuse: { fr: "Refusé", en: "Refused" },
  archive: { fr: "Archivé", en: "Archived" },
};

export const LOG_ACTIONS = {
  document_recu: { fr: "Document reçu", en: "Document received" },
  document_accepte: { fr: "Document accepté", en: "Document accepted" },
  document_refuse: { fr: "Document refusé", en: "Document refused" },
  document_demande: { fr: "Document demandé", en: "Document requested" },
  dossier_revise: { fr: "Dossier révisé", en: "Dossier reviewed" },
  decision_reportee: { fr: "Décision reportée", en: "Decision deferred" },
  decision_approuvee_demo: { fr: "Décision approuvée démo", en: "Demo decision approved" },
  decision_refusee_demo: { fr: "Décision refusée démo", en: "Demo decision refused" },
  import_prepare: { fr: "Import préparé", en: "Import prepared" },
  apercu_genere: { fr: "Aperçu généré", en: "Preview generated" },
  import_confirme: { fr: "Import local confirmé", en: "Local import confirmed" },
  import_annule: { fr: "Import annulé", en: "Import cancelled" },
  validation_requise: { fr: "Validation requise", en: "Validation required" },
};

/**
 * @param {Record<string, {fr: string, en: string}>} map
 * @param {string} key
 * @param {'fr'|'en'} locale
 */
export function authDocLabel(map, key, locale) {
  const entry = map[key];
  if (!entry) return key;
  return locale === "en" ? entry.en : entry.fr;
}
